import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { piggybankService } from '@/services/piggybank';

export function usePiggybankList() {
    const crudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({ request: piggybankService.item.list });

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: piggybankService.item.disable,
            onSuccess: () => fetchList()
        }),
        enable: crudAction.confirmAndEnable({
            request: piggybankService.item.enable,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: piggybankService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
